import { getTypographyLineHeight } from '../../../Typography/styles.native';

export function getNativeLineHeight(textSize?: string): string {
  if (!textSize) return '';

  const lineHeight = getTypographyLineHeight(textSize);
  if (!lineHeight) return '';

  return `leading-[${lineHeight}px]`;
}
